import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Mic, PenLine } from "lucide-react";
import { formatDate } from "@/lib/dates";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function MemoryCard({ memory }) {
    const src = memory.storage_path ? `${API}/files/${memory.storage_path}` : "";
    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, ease: [0.76, 0, 0.24, 1] }}
        >
            <Link
                to={`/memories/${memory.memory_id}`}
                data-testid={`memory-card-${memory.memory_id}`}
                className="block overflow-hidden rounded-3xl border-2 border-warmgray bg-ivory transition-transform duration-300 hover:-translate-y-1"
            >
                {memory.memory_type === "photo" && (
                    <img src={src} alt={memory.title || memory.caption || "Family memory"} loading="lazy" className="aspect-square w-full object-cover" />
                )}
                {memory.memory_type === "video" &&
                    (memory.thumbnail_path ? (
                        <div className="relative">
                            <img
                                src={`${API}/files/${memory.thumbnail_path}`}
                                alt={memory.title || memory.caption || "Family video"}
                                loading="lazy"
                                className="aspect-square w-full object-cover"
                            />
                            <span className="absolute bottom-3 right-3 flex h-9 w-9 items-center justify-center rounded-full bg-navy/80 backdrop-blur-sm">
                                <svg width="12" height="14" viewBox="0 0 12 14" fill="white" aria-hidden="true"><path d="M0 0l12 7-12 7z" /></svg>
                            </span>
                        </div>
                    ) : (
                        <video src={src} preload="metadata" className="pointer-events-none aspect-square w-full bg-navy object-cover" />
                    ))}
                {memory.memory_type === "audio" && (
                    <div className="flex aspect-square w-full flex-col items-center justify-center bg-gradient-to-br from-lavender to-peach p-6">
                        <Mic size={36} className="text-white" />
                        <p className="mt-3 font-mono text-[10px] uppercase tracking-[0.25em] text-white/90">Voice story</p>
                    </div>
                )}
                {memory.memory_type === "story" && (
                    <div className="flex aspect-square w-full flex-col justify-center bg-cream p-6">
                        <PenLine size={24} className="text-peach" />
                        <p className="mt-3 line-clamp-5 font-display text-base italic leading-relaxed text-navy">
                            “{memory.story}”
                        </p>
                    </div>
                )}
                <div className="p-4">
                    {memory.title && <p className="font-display text-lg leading-snug text-navy">{memory.title}</p>}
                    {memory.caption && <p className="mt-0.5 line-clamp-2 text-sm font-medium text-navy">{memory.caption}</p>}
                    <p className="mt-1 font-mono text-[10px] uppercase tracking-widest text-[#2C3347]">
                        {memory.author_name} · {formatDate(memory.memory_date || memory.created_at)}
                    </p>
                </div>
            </Link>
        </motion.div>
    );
}
